export default "__VITE_ASSET__DgpY$qCN__"